import { boolishToBool } from 'x1-base/utils';
import { useSessionId } from '~/composables';

function safeGetLocalStorageItem(key: string): string | null {
    try {
        return typeof localStorage !== 'undefined' && typeof localStorage.getItem === 'function'
            ? localStorage.getItem(key)
            : null;
    } catch {
        return null;
    }
}

export default defineNuxtPlugin({
    name: 'init',
    async setup(nuxtApp) {
        const isDebug = boolishToBool(safeGetLocalStorageItem('DEBUG') ?? false) ?? false;
        nuxtApp.vueApp.provide('isDebug', isDebug);

        const { getOrGenSessionId } = useSessionId();
        const id = await getOrGenSessionId();

        console.info('SESSION ID: ', id);
    }
});
